import { useSWRMutation } from '@tiger/swr';
import WeakNetPrompt from 'components/forms/WeakNetPrompt';
import API from 'utils/API';
import { CheckRegexResponse, RegexTypeEnum } from './type';

/**
 * 开户表单值校验是否为有效的拉丁字符 https://project.feishu.cn/itiger/story/detail/6422595679
 */
export function useCheckLatin(type: RegexTypeEnum, fieldName: string = '') {
    const { isMutating, ...restSwrResp } = useSWRMutation<boolean, string>(API.CUSTOMER.postRegexCheck(), value =>
        API.CUSTOMER.postRegexCheck
            .post<CheckRegexResponse[]>(
                {
                    items: [
                        {
                            text: value,
                            regex_type: type
                        }
                    ]
                },
                {
                    useJson: true
                }
            )
            .then(res =>
                res.data[0].passed
                    ? Promise.resolve(true) // 这里返回promise的值是用于formutil的checker异步校验
                    : Promise.reject(__('Please do not enter non-Latin characters'))
            )
    );

    const renderCheckingPrompt = () => {
        return isMutating ? (
            <WeakNetPrompt
                name={`temporary_check_${type}_${fieldName}`}
                type="loading"
                errorText={__('正在校验中，请稍等')}
            />
        ) : null;
    };

    return {
        ...restSwrResp,
        isMutating,
        renderCheckingPrompt
    };
}

export * from './type';
